import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../../redux/hooks";

import { UsersListInterface } from "../../../../redux/interfaces/admin.interface";

import moment from "moment";
import "moment/locale/ro";

import Dropdown, { DropdownValue } from "../../../../components/misc/Dropdown";
import { getCurrentYearOrMonth } from "../../../../utils/dateAndTime";
import useTableCtx from "../../../../components/tables/tableContext/useTableCtx";
import CustomButton from "../../../../components/CustomButton";
import { getDownloadMonthActivityReports } from "../../../../redux/api/reports.api";
import SvgIcon from "../../../../helpers/SvgIcon";

const lastThreeYears = [
  getCurrentYearOrMonth("year"),
  getCurrentYearOrMonth("year") - 1,
  getCurrentYearOrMonth("year") - 2,
];

const usersRole = [
  { id: "putAway", label: "Taskuri Putaway" },
  { id: "rearanjare", label: "Taskuri Rearanjare" },
  { id: "umplere", label: "Taskuri Umplere" },
  { id: "comenziColectate", label: "Comenzi Colectate" },
  { id: "comenziVerificate", label: "Comenzi Verificate" },
  { id: "receptiiDeschise", label: "Receptii Deschise" },

  { id: "putAwayNrProduse", label: "Produse Putaway" },
  { id: "rearanjareNrProduse", label: "Produse Rearanjare" },
  { id: "umplereNrProduse", label: "Produse Umplere" },

  { id: "comenziColectateNrPozitii", label: "Poziții Colectate" },
  { id: "comenziColectateNrProduse", label: "Produse Colectate" },

  { id: "comenziVerificateNrPozitii", label: "Poziții Verificate" },
  { id: "comenziVerificateNrProduse", label: "Produse Verificate" },

  { id: "produseReceptionate", label: "Produse Receptionate" },
  { id: "produseSolutionate", label: "Produse Solutionate" },
  { id: "NrCutiiScanateExpeditie", label: "Cutii Scanate Expeditie" },
  { id: "CantitateMinus", label: "Cantitate Minus (Inventar)" },
  { id: "CantitatePlus", label: "Cantitate Plus (Inventar)" },
  { id: "lotBBD", label: "Lot BBD Procesat" },
];

const monthsDataDropdownValue = moment
  .monthsShort()
  .map((month: string, index: number) => {
    return {
      id: index + 1,
      label: month,
    };
  });

const yearsDataDropdownValue = lastThreeYears.map((year: number) => {
  return {
    id: year,
    label: year,
  };
});

const usersRoleDropdownValue = usersRole.map((role) => {
  return {
    id: role.id,
    label: role.label,
  };
});

function DropdownsPageHeader() {
  const dispatch = useAppDispatch();
  const { handleTableSearch } = useTableCtx() || {};

  const [selectedMonth, setSelectedMonth] = useState<DropdownValue>(
    monthsDataDropdownValue[getCurrentYearOrMonth("month", 1)],
  );
  const [selectedYear, setSelectedYear] = useState<DropdownValue>(
    yearsDataDropdownValue[0],
  );
  const [selectedUsers, setSelectedUsers] = useState<DropdownValue[]>([]);
  const [selectedRoles, setselectedRoles] = useState<DropdownValue[]>([]);

  const {
    admin: {
      users: {
        data: { data: users },
      },
    },
  } = useAppSelector((state) => ({
    admin: state.admin,
  }));

  useEffect(() => {
    handleTableSearch && handleTableSearch("selectedMonth", selectedMonth?.id);
  }, [handleTableSearch, selectedMonth]);

  useEffect(() => {
    handleTableSearch && handleTableSearch("selectedYear", selectedYear?.id);
  }, [handleTableSearch, selectedYear]);

  useEffect(() => {
    handleTableSearch &&
      handleTableSearch("selectedUsers", JSON.stringify(selectedUsers));
  }, [handleTableSearch, selectedUsers]);

  useEffect(() => {
    handleTableSearch &&
      handleTableSearch("selectedRoles", JSON.stringify(selectedRoles));
  }, [handleTableSearch, selectedRoles]);

  const handleDownloadReport = async () => {
    await dispatch(
      getDownloadMonthActivityReports({
        month: selectedMonth?.id,
        year: selectedYear?.id,
      }),
    );
  };

  const usersDropdownValue = users.map((user: UsersListInterface) => {
    return {
      id: user.userId,
      label: user.userName,
    };
  });

  return (
    <div>
      <div className="d-flex justify-content-center">
        <Dropdown
          className="mb-4 me-2"
          title="Selecteaza luna"
          data={monthsDataDropdownValue}
          singleValue={selectedMonth}
          setSingleValue={(value) => value && setSelectedMonth(value)}
        />

        <Dropdown
          className="mb-4 me-2"
          title="Selecteaza anul"
          data={yearsDataDropdownValue}
          singleValue={selectedYear ?? yearsDataDropdownValue[0]}
          setSingleValue={(value) => value && setSelectedYear(value)}
        />

        <Dropdown
          className="mb-4 me-2"
          title="Utilizatori"
          data={usersDropdownValue}
          multipleValues={selectedUsers}
          setMultipleValues={setSelectedUsers}
        />

        <Dropdown
          className="mb-4 me-2"
          title="Roluri"
          data={usersRoleDropdownValue}
          multipleValues={selectedRoles}
          setMultipleValues={setselectedRoles}
        />
      </div>
      <div className="d-flex justify-content-end">
        <CustomButton
          variant="contained"
          tooltipTitle="Exporta datele in csv"
          onClick={handleDownloadReport}>
          <SvgIcon fill="white" type="DOCUMENT_WITH_DOWNLOAD" />
        </CustomButton>
      </div>
    </div>
  );
}

export default DropdownsPageHeader;
